<template>
  <NavBar></NavBar>
  <el-scrollbar class="scrollbar">
    <div class="container">
      <router-view></router-view>
<!--      <router-view v-slot="{ Component }">
        <transition name="slide-fade">
          <component :is="Component"/>
        </transition>
      </router-view>-->
    </div>
    <web-footer class="footer"></web-footer>
  </el-scrollbar>

</template>

<script>

import NavBar from "@/components/NavBar";
import WebFooter from "@/components/WebFooter";

export default {
  name: 'App',
  components: {
    NavBar,
    WebFooter
  },
  data() {
    return {
      desktop: false
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

html {
  height: 100%;
}

body {
  margin: 0;
  height: 100%;
}

.scrollbar {
  height: calc(100% - 61px) !important;
}

.el-scrollbar__view {
  min-height: 100%;
  position: relative;
  bottom: 1px;
}

.container {
  padding-bottom: 180px;
}

.footer {
  position: absolute;
  bottom: 0;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity .3s;
}

.fade-leave {
  opacity: 1;
}

.fade-leave-active {
  opacity: 0;
  transition: opacity .3s;
  -webkit-transition: opacity .3s;
}

.slide-left-enter-to, .slide-right-leave-to {
  opacity: 0;
  transform: translateX(100%);
  -webkit-transform: translateX(100%)
}

.slide-left-leave-to, .slide-right-enter-to {
  opacity: 0;
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
}

.slide-left-enter-active, .slide-left-leave-active, .slide-right-enter-active, .slide-right-leave-active {
  transition: .3s;
  -webkit-transition: .3s;
}

.slide-fade-enter-active {
  transition: all .4s ease-out;
}

.slide-fade-leave-active {
  transition: all .3s ease-out;
}

.slide-fade-enter-from {
  transform: translateX(-100vw);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(100vw);
  opacity: 0;
}
</style>
